import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [staff, setStaff] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshStaff = async () => {
    try {
      const res = await api.get('/auth/me');
      if (res.data?.staff) {
        setStaff(res.data.staff);
      }
    } catch {
      // Ignore - token may be invalid
    }
  };

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const res = await api.get('/auth/me');
          if (res.data?.staff) {
            setIsAuthenticated(true);
            setStaff(res.data.staff);
          }
        } catch {
          localStorage.removeItem('token');
        }
      }
      setLoading(false);
    };
    checkAuth();

    const handlePermissionsRefreshed = () => {
      refreshStaff();
    };
    window.addEventListener('auth:permissions-refreshed', handlePermissionsRefreshed);
    return () => window.removeEventListener('auth:permissions-refreshed', handlePermissionsRefreshed);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await api.post('/auth/login', {
        email,
        password,
      });
      
      const { token, staff: staffData } = response.data;
      localStorage.setItem('token', token);
      setIsAuthenticated(true);
      setStaff(staffData);
      return { success: true };
    } catch (error) {
      // Check if it's a connection error
      if (error.code === 'ERR_NETWORK' || error.code === 'ERR_CONNECTION_REFUSED' || !error.response) {
        return {
          success: false,
          message: 'Cannot connect to server. Start the backend: open a terminal in the project folder and run: npm start  (or ./start-backend.sh). The server should listen on port 5001.',
        };
      }
      return {
        success: false,
        message: error.response?.data?.message || 'Login failed',
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setStaff(null);
  };

  const value = {
    isAuthenticated,
    staff,
    login,
    logout,
    loading,
    refreshStaff,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
